import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { CustomerRegisterRequestBody, CustomerRegisterResponse } from "./types";

export class CustomerRegisterAPI extends BaseAPI<
  CustomerRegisterRequestBody,
  CustomerRegisterResponse
> {
  protected route = ApiRoutes.customer.register;
  protected method = RequestMethod.POST;
}
